import { SafeLink } from "@/components/ui/SafeLink";
import { Button } from "@/components/ui/button";
import { SlideFromLeft, SlideFromRight } from "@/components/ui/animations";

export default function Tiles() {
    return (
        <div className="flex flex-col w-full bg-gradient-to-b from-gray-50 to-gray-100 relative overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/4 w-32 h-32 bg-red-500/3 rounded-full blur-3xl"></div>
                <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-gray-900/2 rounded-full blur-3xl"></div>
            </div>

            {/* Effortless Entertainment */}
            <SlideFromLeft Component={
                <div id="effortless-entertainment" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/NewWebPhotos/Homepage/hnc-web-homepage-secure-guest-casting.jpg`}
                                alt="Guest casting video from smartphone to TV screen"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-8 lg:px-0 px-4 text-center  lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Effortless </span> Entertainment
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                No more outdated TV menus or limited channels. Guests stream their favourite shows, movies, and music from any device—fast and frustration-free.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Enhanced Guest Satisfaction */}
            <SlideFromRight Component={
                <div id="enhanced-guest-satisfaction" className=" lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col  lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/hnc-web-secure-guest-satisfaction.png`}
                                alt="Hotel room with five-star guest review and neatly made bed"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto  lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Enhanced </span> Guest Satisfaction

                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                A smooth, intuitive experience keeps guests happy—driving better reviews, higher recommendations, and more repeat bookings.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Seamless Security */}
            <SlideFromLeft Component={
                <div id="seamless-security" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/hnc-web-secure-guest-data-security.png`}
                                alt="Digital security concept with padlock shield and network connections"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 xl:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Seamless  </span> Security
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Privacy comes first. Our casting system keeps every guest’s data and content protected—reducing security risks for your business.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Fewer Support Calls */}
            <SlideFromRight Component={
                <div id="fewer-support-calls" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/hnc-blog-nevaya-pairing.jpg`}
                                alt="Hotel guest signing in via smartphone with clear instructions on TV screen"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Fewer </span> Support Calls
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Easy setup means guests need less help, freeing your staff to deliver a truly memorable service.
                            </p>
                        </div>
                    </div>
                </div>
            } />


        </div>
    )
}